// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"ShipmentsListView_itemContainer__Qx9HF","rowWrapToColumn":"ShipmentsListView_rowWrapToColumn__2GzFI","noRowsToShow":"ShipmentsListView_noRowsToShow__1kl_g"};